import '../themeDefaults';

export default ({
  formComponents
}) => ({
  helpWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  root: ({ inline }) => ({
    marginBottom: formComponents.container.marginBottom,
    ...(inline
      ? {
        display: 'flex',
        justifyContent: 'center'
      }
      : {
        display: 'block'
      })
  }),
  wrap: {
    width: '100%'
  }
});
